import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { Fornecedor } from 'src/app/admihair/api/dto/fornecedor';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FornecedorService } from 'src/app/admihair/service/fornecedor.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-fornecedor-detalhar',
  templateUrl: './fornecedor-detalhar.component.html',
  styleUrls: ['./fornecedor-detalhar.component.scss']
})
export class FornecedorDetalharComponent implements OnInit {

  permissaoDetalhar: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  id?: number;
  fornecedor?: Fornecedor;
  loading: boolean = true;
  @ViewChild('f') form?: NgForm;

  constructor(private activatedRouter: ActivatedRoute,
    private fornecedorService: FornecedorService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_FORNECEDOR');
    this.carregarIdFornecedor();
    if (this.permissaoDetalhar) {
      this.carregarFornecedorPorId();
    }
  }

  carregarFornecedorPorId() {
    this.fornecedorService.buscarPorId(this.id).subscribe({
      next: (data: Fornecedor) => {
        this.fornecedor = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  carregarIdFornecedor() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }

  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

}
